// External imports
import axios from "axios";
import endPoints from "../../_services/endpoints";
import moment from "moment";
import { setEditInitialState } from "./editTaskActions";
import { env } from "../../_services/env";

// Create Redux action types
export const GET_TASKS = "GET_TASKS";
export const GET_TASKS_SUCCESS = "GET_TASKS_SUCCESS";
export const GET_TASKS_FAILURE = "GET_TASKS_FAILURE";

// Task Dropdown Lists action types
export const GET_DROPDOWN_LISTS = "GET_DROPDOWN_LISTS";
export const GET_DROPDOWN_LISTS_SUCCESS = "GET_DROPDOWN_LISTS_SUCCESS";
export const GET_DROPDOWN_LISTS_FAILURE = "GET_DROPDOWN_LISTS_FAILURE";

// Create Redux action types
export const ADD_TASK = "ADD_TASK";
export const ADD_TASK_FAILURE = "ADD_TASK_FAILURE";

// Create Redux action creators that return an action
export const getTasks = () => ({
	type: GET_TASKS,
});

export const getTasksSuccess = (tasks) => ({
	type: GET_TASKS_SUCCESS,
	payload: tasks,
});

export const getTasksFailure = () => ({
	type: GET_TASKS_FAILURE,
});

// Create Redux action creators that return an action
export const getTaskDropdownLists = () => ({
	type: GET_DROPDOWN_LISTS,
});

export const getTasksDropdownListsSuccess = (lists) => ({
	type: GET_DROPDOWN_LISTS_SUCCESS,
	payload: lists,
});

export const getTaskDropdownListsFailure = () => ({
	type: GET_DROPDOWN_LISTS_FAILURE,
});

// Fetch tasks
export function fetchTasks() {
	return async (dispatch) => {
		dispatch(getTasks());
		// dispatch(setEditInitialState())

		try {
			const loggedInUserData = JSON.parse(localStorage.getItem("userData"));
			if (loggedInUserData) {
				if (loggedInUserData.Token) {
					axios.defaults.headers["ApplicationSecurityCode"] =
						loggedInUserData.ApplicationSecurityCode;
					axios.defaults.headers.common["SECURIT_IDENTITY"] =
						loggedInUserData.Token;
				}
			}
			const response = await axios.get(endPoints.allTasks);
			const data = await response.data;

			data.map((x) => {
				if (x.TaskStatusId === 1) {
					x.TaskStatusId = "New";
				} else if (x.TaskStatusId === 2) {
					x.TaskStatusId = "Stop";
				} else if (x.TaskStatusId === 3) {
					x.TaskStatusId = "Running";
				} else {
					x.TaskStatusId = "Completed";
				}

				if (x.FileSourceTypeId === 1) {
					x.FileSourceTypeId = "Inbound";
				} else if (x.FileSourceTypeId === 2) {
					x.FileSourceTypeId = "Outbound";
				}

				x.StartDate = moment(x.StartDate).format("MM/DD/YYYY");

				x.CreatedDate = moment(x.CreatedDate).format("MM/DD/YYYY");
				x.ModifiedDate = moment(x.ModifiedDate).format("MM/DD/YYYY");

				return data;
			});

			dispatch(getTasksSuccess(data));
		} catch (error) {
			dispatch(getTasksFailure());
		}
	};
}

// Fetch dropdown lists
export function fetchTaskDropdownLists() {
	return async (dispatch) => {
		dispatch(getTaskDropdownLists());
		try {
			const loggedInUserData = JSON.parse(localStorage.getItem("userData"));
			if (loggedInUserData) {
				if (loggedInUserData.Token) {
					axios.defaults.headers["ApplicationSecurityCode"] =
						loggedInUserData.ApplicationSecurityCode;
					axios.defaults.headers.common["SECURIT_IDENTITY"] =
						loggedInUserData.Token;
				}
			}
			const response = await axios.get(endPoints.newTask);
			const data = await response.data;

			dispatch(getTasksDropdownListsSuccess(data));
		} catch (error) {
			dispatch(getTaskDropdownListsFailure());
		}
	};
}

// Add task fn
export const addTaskSuccess = (task) => ({
	type: ADD_TASK,
	payload: task,
});
export const addTaskFailure = () => ({
	type: ADD_TASK_FAILURE,
});

export function addTask(task) {
	return async (dispatch) => {
		dispatch(getTasks());
		// dispatch(setEditInitialState())

		let weekObj = {
			Id: 0,
			ClientId: task.ClientId,
			FileSourceTypeId: task.FileSourceTypeId,
			FileTypeId: task.FileTypeId,
			FileFormatId: task.FileFormatId,
			EDITaskTypeId: task.EDITaskTypeId,
			TaskName: task.TaskName,
			FileNameFormat: task.FileNameFormat,
			ReadTries: task.ReadTries,
			FileOutputPath: task.OutboundResponsePath,
			SuccessArchivePath: task.SuccessArchivePath,
			FailureArchivePath: task.FailureArchivePath,
			File_Receive_Path: task.File_Receive_Path,
			Notify: task.Notify,
			notifyemail: task.NotifyEmail,

			ScheduleTypeId: task.ScheduleTypeId,
			EveryXWeeks: task.EveryXWeeks,
			ScheduleWeekday: task.ScheduleWeekday,

			SpecificTime: task.SpecificTime,
			EveryXminutes: task.EveryXminutes,
			TimeRecurrenceTypeId: task.TimeRecurrenceTypeId,
			StartTime: task.StartTime,
			EndTime: task.EndTime,

			StartDate: task.StartDate,
			EndDate: task.EndDate,

			CreatedBy: task.CreatedBy,
			ModifiedBy: task.ModifiedBy,
			IsExcludeHolidays: task.IsExcludeHolidays,
		};

		let obj = {
			Id: task.Id,
			ClientId: task.ClientId,
			FileSourceTypeId: task.FileSourceTypeId,
			FileTypeId: task.FileTypeId,
			FileFormatId: task.FileFormatId,
			EDITaskTypeId: task.EDITaskTypeId,
			TaskName: task.TaskName,
			FileNameFormat: task.FileNameFormat,
			ReadTries: task.ReadTries,
			FileOutputPath: task.OutboundResponsePath,
			SuccessArchivePath: task.SuccessArchivePath,
			FailureArchivePath: task.FailureArchivePath,
			File_Receive_Path: task.File_Receive_Path,
			Notify: task.Notify,
			NotifyEmail: task.NotifyEmail,
			ScheduleTypeId: task.ScheduleTypeId,
			EveryXDays: task.EveryXDays,
			EveryXWeeks: task.EveryXWeeks,
			ScheduleWeekday: task.ScheduleWeekday,
			DayOfMonth: task.DayOfMonth,
			EveryXMonths: task.EveryXMonths,
			MonthlySpecificDatePartOne: task.MonthlySpecificDatePartOne,
			MonthlySpecificDatePartTwo: task.MonthlySpecificDatePartTwo,
			EveryXMonths2: task.EveryXMonths2,
			SpecificTime: task.SpecificTime,
			EveryXminutes: task.EveryXminutes,
			TimeRecurrenceTypeId: task.TimeRecurrenceTypeId,
			StartTime: task.StartTime,
			EndTime: task.EndTime,
			StartDate: task.StartDate,
			EndDate: task.EndDate,
			CreatedBy: task.CreatedBy,
			ModifiedBy: task.ModifiedBy,
			DayOfQuarterlyMonth: task.DayOfQuarterlyMonth,
			EveryXQuarterlyMonths: task.EveryXQuarterlyMonths,
			EveryXQuarterlyMonths2: task.EveryXQuarterlyMonths2,
			MonthOfQuarterly: task.MonthOfQuarterly,
			MonthOfQuarterly2: task.MonthOfQuarterly2,
			QuarterlySpecificDatePartOne: task.QuarterlySpecificDatePartOne,
			QuarterlySpecificDatePartTwo: task.QuarterlySpecificDatePartTwo,
			IsExcludeHolidays: task.IsExcludeHolidays,
		};

		let apiObj = {};
		if (task.ScheduleTypeId === 2) {
			apiObj = weekObj;
		} else {
			apiObj = obj;
		}

		const loggedInUserData = JSON.parse(localStorage.getItem("userData"));
		if (loggedInUserData) {
			if (loggedInUserData.Token) {
				axios.defaults.headers["ApplicationSecurityCode"] =
					loggedInUserData.ApplicationSecurityCode;
				axios.defaults.headers.common["SECURIT_IDENTITY"] =
					loggedInUserData.Token;
			}
		}

		await axios
			.post(endPoints.addTask, apiObj)
			.then((res) => {
				dispatch(addTaskSuccess(task));
				dispatch(fetchTasks());
			})
			.catch((error) => {
				dispatch(addTaskFailure());
			});
	};
}
